import { ArticleElementTypes, ElementPosition } from "types/injector";
import doesMatchType from "utils/csi/doesMatchType";

const DROPCAP_HEIGHT = 100;
const DROPCAP_MOBILE_HEIGHT = 80;

/** Get the top and bottom position of each element */
const getPositions = (
  elementsArr: HTMLElement[],
  componentsArr: JSX.Element[],
  isMobile: boolean
): ElementPosition[] => {
  const positions: ElementPosition[] = [];
  elementsArr.forEach((element, i) => {
    // Detect thin wrappers around floats. To get the true layout, look at
    // the first child
    if (element.offsetHeight == 0 && element.children.length == 1) {
      const child = element.children.item(0);
      if (child && child instanceof HTMLElement && child.offsetHeight > 0) {
        element = child;
      }
    }

    const style = getComputedStyle(element);
    const topMargin = parseInt(style["marginTop"]) || 0;
    const bottomMargin = parseInt(style["marginBottom"]) || 0;
    positions[i] = {
      top: element.offsetTop,
      topMargin: element.offsetTop - topMargin,
      bottom: element.offsetTop + element.offsetHeight,
      bottomMargin: element.offsetTop + element.offsetHeight + bottomMargin,
    };

    // for the first element, start counting at the bottom of the header
    if (i == 0) {
      const header = element.parentElement?.previousElementSibling;
      if (header instanceof HTMLElement) {
        positions[i].topMargin = positions[i].top =
          header.offsetTop + header.offsetHeight || 0;
      }
    }

    // for dropcap paragraphs, set the minimum height to 100px to accomodate the dropcap letter
    // even for short paragraphs
    if (
      doesMatchType(ArticleElementTypes.Dropcap, element, componentsArr[i], i)
    ) {
      const dropcapHeight = isMobile ? DROPCAP_MOBILE_HEIGHT : DROPCAP_HEIGHT;
      // the Y position of the bottom of the dropcap letter
      const dropcapYPos = positions[i].top + dropcapHeight;
      positions[i].bottom = Math.max(dropcapYPos, positions[i].bottom);
      positions[i].bottomMargin = Math.max(
        dropcapYPos,
        positions[i].bottomMargin
      );
    }
  });

  return positions;
};

export default getPositions;
